<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1000"
  >
    <v-card>
      <v-toolbar
        dark
      >
        <v-toolbar-title>
          Message - {{ id }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col style="padding: 0 24px 0 24px;">
            <div style="aligner-items: stretch; display: flex;">
              <v-sheet tile elevation="5" class="pa-3" color="green">
                <div style="text-align: center">
                  <div>Starts On</div>
                  <div><b>{{startDate}}</b></div>
                </div>
              </v-sheet>
              <hr class="v-divider theme--light" style="align-self: center; margin: 0 12px;">
              <v-sheet tile elevation="5" class="pa-3" color="red">
                <div style="text-align: center">
                  <div>Ends On</div>
                  <div><b>{{endDate}}</b></div>
                </div>
              </v-sheet>
            </div>
          </v-col>
        </v-row>
        <v-row style="margin-top:20px;">
          <v-col style="padding: 0 24px 0 24px;" cols="4">
            <div style="font-weight:bold;text-align:right;">Header</div>
          </v-col>
          <v-col style="padding: 0 24px 0 24px;" cols="8">
            {{ header }}
          </v-col>
        </v-row>
        <v-row style="margin-top:10px">
          <v-col style="padding: 0 24px 0 24px;" cols="4">
            <div style="font-weight:bold;text-align:right;">Body</div>
          </v-col>
          <v-col style="padding: 0 24px 0 24px;" cols="8">
            {{ body }}
          </v-col>
        </v-row>
        <v-row style="margin-top:10px">
          <v-col style="padding: 0 24px 0 24px;" cols="4">
            <div style="font-weight:bold;text-align:right;">Call to Action</div>
          </v-col>
          <v-col style="padding: 0 24px 0 24px;" cols="8">
            {{ callToAction }}
          </v-col>
        </v-row>

        <v-row style="margin-top:10px">
          <v-col style="padding: 0 24px 0 24px;" cols="4">
            <div style="font-weight:bold;text-align:right;">Market</div>
          </v-col>
          <v-col style="padding: 0 24px 0 24px;" cols="8">
            {{ market }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="grey lighten-1" @click="onCloseClick()">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: Boolean,
    id: String,
    startDate: String,
    endDate: String,
    header: String,
    body: String,
    callToAction: String,
    market: String,
  },

  data() {
    return {
    };
  },

  computed: {
  },

  mounted() {
  },

  methods: {
    onCloseClick() {
      this.$emit('close');
    },
  },
};
</script>
